// extracted by mini-css-extract-plugin
export default {"articlePage":"article_page_articlePage__wJvV9","blocksContainer":"article_page_blocksContainer__xy-qK","blockWrapper":"article_page_blockWrapper__jKnZn"};